// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__38jtP","description":"PatientConsentPreview_description__33Geg"};